import React, { forwardRef } from 'react';
import { IInputProps } from '../Input.model';
import * as S from '../Input.styles';
import { useDateInput } from './hooks';

export const DateInput = forwardRef<HTMLInputElement, IInputProps>(
  (
    {
      defaultValue,
      onChangeDateInput,
      onClick,
      type,
      onDateClickOutSide,
      setError,
      requiredText,
      disabled,
      isDatePickerOpen,
      dateInputStart,
      ...props
    },
    ref,
  ) => {
    const { value, inputHandler, blurHandler } = useDateInput({
      onChangeDateInput,
      onDateClickOutSide,
      setError,
      defaultValue,
      disabled,
      requiredText,
      isDatePickerOpen,
      dateBegin: dateInputStart,
    });

    return (
      <S.StyledInput
        type='text'
        value={value}
        onChange={inputHandler}
        onBlur={blurHandler}
        onClick={onClick}
        ref={ref}
        disabled={disabled}
        {...props}
      />
    );
  },
);
